import { emulatorScreen, mobileScreen } from "../utils/styleUtils";

const styles = (theme) => ({
  labelContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "flex-start",
    paddingLeft: "5%",
    [emulatorScreen(theme)]: {},
    [mobileScreen(theme)]: {
      paddingLeft: "2%",
    },
  },
  dragText: { 
    color: "#003e4c",
    fontSize: 20,
    textAlign: 'left',
    width: "83%",
    fontFamily: "Oswald",
    [emulatorScreen(theme)]: {},
    [mobileScreen(theme)]: {
      fontSize: 12,
      margin: 0,
      marginTop: 5,
    },
  },
  optionContainer: {
    display: "flex", justifyContent: "space-between", flexDirection: 'row', width: "85%",
    [emulatorScreen(theme)]: {},
    [mobileScreen(theme)]: {
      // marginTop: 10,
      height: 35,
      alignItems: 'center',
    },
  },
  optiontext: {
    color: "#003e4c", fontSize: 18, margin: 15, textAlign: 'left',
    [mobileScreen(theme)]: {
      fontSize: 12,
      margin: 0,
      marginTop: 0,
    },
  },
  headingText: {
    color: "#003e4c",
    fontSize: 20,
    textAlign: 'left',
    width: "83%",
    fontFamily: "Oswald",
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {
      fontSize: 14,
      // margin: 2,
      // paddingLeft: 5,
    },
  },
  innerlabelsContainer: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: 'row',
    width: "80%",
    alignItems: "center",
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {

    },
  },
  labels: {
    color: "#003e4c",
    fontSize: 18,
    margin: 15,
    textAlign: 'left',
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {
      fontSize: 12,
      marginTop: "15px 5px",
    },
  },
  DropableLabel1: {
    position: "absolute",
    right: -140,
    display: "flex",
    flexDirection: "column",
    alignItems: "end",
    width: "100%",
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {
      right: -25,
    },
  },
  DropableLabel2: {  
    width: 150,
    marginRight: -264,
    // marginRight: screenSize < 1450 ? -253 : -270,
    display: "flex",
    height: 60,
    justifyContent: "end",
    alignItems: "center",
    marginTop: 190,
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {
      marginRight: -175,
      marginTop: 115,
    },
  },
  dropableLabelsContainer: {
    position: "absolute", right: -140, display: "flex", flexDirection: "column", alignItems: "end", width: "100%",
    [mobileScreen(theme)]: {
      right: -30
    },
  }
});
export default styles;
